// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"MainSection_mainContainer__2NA5_","displayContainer":"MainSection_displayContainer__18kpf","inputMainContainer":"MainSection_inputMainContainer__1vr9M"};